import * as React from 'react';
import ContactInput from './ContactInput';
import MiniContactMasterEditor from './MiniContactMasterEditor';
import classnames from 'classnames';

import { HelpTooltip } from 'common/components/core/help';
import { Contact } from 'common/models/internal/Contact';
import Icon from 'common/components/core/icon';

class EntityContactInput extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isContactFormVisible: false
        };
    }

    onShowContactForm = () => {
        this.setState({ isContactFormVisible: true });
    };

    onHideContactForm = contact => {
        this.setState({ isContactFormVisible: false });
        if (contact.clientId) {
            //Handling case when contact form is closed without adding new contact
            this.props.onChange(Contact.fromJS(contact));
        }
    };
    getAddContact = () => {
        const { translationsObject, theme, disableAddContact } = this.props;
        return !disableAddContact ? (
            <div
                className={theme.addEntityBtn}
                onClick={this.onShowContactForm}
            >
                <span>{`+ ${translationsObject.addContactText}`}</span>
            </div>
        ) : null;
    };
    getOverrideMessage = () => {
        const { contact, theme, translationsObject } = this.props;
        const overrideMessage = (
            <div className={theme.overrideMessageContainer}>
                <Icon theme={theme} icon="alert" />
                <span className={theme.overrideMessage}>
                    {translationsObject.overrideMessage}
                </span>
            </div>
        );
        return contact ? overrideMessage : null;
    };
    getFooter = () => {
        return (
            <React.Fragment>
                {this.getAddContact()}
                {this.getOverrideMessage()}
            </React.Fragment>
        );
    };

    render() {
        const {
            clientId,
            teamIds,
            contact,
            onChange,
            translationsObject,
            theme,
            field
        } = this.props;
        const { isContactFormVisible } = this.state;
        return (
            <div className={theme.fieldGroup} data-test-id={field.accessor}>
                <div className={theme.row}>
                    {translationsObject.label ? (
                        <span
                            className={classnames(
                                theme.label,
                                theme.horizontal
                            )}
                        >
                            {translationsObject.label}
                            {translationsObject.helpText ? (
                                <HelpTooltip
                                    tooltipText={translationsObject.helpText}
                                />
                            ) : null}
                        </span>
                    ) : null}
                </div>
                <ContactInput
                    className={theme.horizontal}
                    clientId={clientId}
                    teamIds={teamIds}
                    contact={contact}
                    onContactChange={onChange}
                    theme={theme}
                    footer={this.getFooter()}
                />
                {isContactFormVisible ? (
                    <MiniContactMasterEditor
                        field={field}
                        theme={theme}
                        defaultSelectedTeams={teamIds}
                        onDismiss={this.onHideContactForm}
                    />
                ) : null}
            </div>
        );
    }
}

export default EntityContactInput;
